export default "__VITE_ASSET__9bb2d049__"